import type { Stripe, StripeElementsOptions } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { logError } from 'shared/lib/log-errors';
import { STRIPE_KEY, API_VERSION } from 'shared/constants';

export function useStripePromise() {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);

  useEffect(() => {
    setTimeout(() => {
      try {
        const stripe = loadStripe(STRIPE_KEY, {
          apiVersion: API_VERSION,
        });

        setStripePromise(stripe);
      } catch (err) {
        logError(err, { contextKey: 'Stripe', contextPayload: { message: 'Error while load stripe promise' } });
      }
    }, 300);
  }, []);

  return stripePromise;
}

export const StripeOptions: StripeElementsOptions = {
  locale: 'en',
  fonts: [
    {
      cssSrc:
        'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700&amp;family=Open+Sans:ital,wght@0,400;0,600;0,700;1,400&amp;display=swap',
    },
  ],
};
